import {Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Dropdown from "../../../../primer/Dropdown";
import axios from "axios";
import {useSelector} from "react-redux";
import {toast} from "react-toastify";
import {transportTypes} from "../../../../../_data/mydata/transportTypes";
import Input from "../../../../common/Input";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import AdvancedCombobox from "../../../../primer/AdvancedCombobox";
import PackingsDeclarations from "../../../../primer/POPUP-COMPONENTS/PackingsDeclarations/PackingsDeclarations";

const RegisterTransferModal = ({show, setShow, qrUrls, defaultPD = [], otherCorrelatedEntity = null, successCallback}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const initRequestData = {
        vehicleNumber: "",
        transportType: "1",
        carrierVatNumber: "",
        pNumber: "",
        location: {},
        longitude: "",
        latitude: "",
        packingsDeclarations: [],
    }
    const [selectedClient, setSelectedClient] = useState({_id: "", name: ""});
    const [requestData, setRequestData] = useState({...initRequestData});
    const [loading, setLoading] = useState(false);
    const [clientsListData, setClientsListData] = useState([]);

    const [transferVehicles, setTransferVehicles] = useState([]);

    useEffect(() => {
        if (!show) {
            setRequestData({...initRequestData});
            setSelectedClient({_id: "", name: ""});
        } else {
            loadTransferVehicles();
            loadClientsListData(null, setClientsListData);
            if (otherCorrelatedEntity) manageAutoTransferCarrier();
            if (defaultPD) {
                setRequestData({...requestData, packingsDeclarations: defaultPD});
            }
        }
    }, [show]);

    const clientDropdownColumns = [
        {
            label: "Όνομα",
            name: "name",
        },
        {
            label: "ΑΦΜ",
            name: "vatNumber",
        },
        {
            label: "Τηλέφωνο",
            name: "phone",
        },
    ];

    const manageAutoTransferCarrier = () => {
        if (otherCorrelatedEntity?.vatNumber) {
            axios.post(`${process.env.REACT_APP_API_URL2}/sale/manage-auto-transfer-carrier`, {
                company: company.id,
                vatNumber: otherCorrelatedEntity.vatNumber,
            }).then((res) => {
                if (res.data.status === "200") {
                    setSelectedClient({_id: res.data.data._id, name: res.data.data.name, vatNumber: res.data.data.vatNumber});
                    setRequestData({...requestData, carrierVatNumber: res.data.data.vatNumber});
                }
            }).catch((err) => {
                console.log(err);
            })
        }
    }

    const loadTransferVehicles = () => {
        axios.post(`${process.env.REACT_APP_API_URL2}/sale/list-transfer-vehicles`, {
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") setTransferVehicles(res.data.data);
        }).catch((err) => {
            console.log(err);
        })
    }

    const onAccept = () => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/sale/register-transfer`, {
            ...requestData,
            qrUrls,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                if (res.data.errors) {
                    for (const err of res.data.errors) {
                        toast.error(err);
                    }
                }
                const successCount = qrUrls.length - res.data.errors.length;
                if (successCount > 0) toast.success(`Επιτυχής καταχώρηση ${successCount} Δ.Α.`);
                setShow(false);
                if (successCallback) successCallback();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            setLoading(false);
        })
    }

    const loadClientsListData = (name, setData) => {
        const reqData = {
            company: company.id,
        }
        if (!isEmpty(name)) reqData.name = name;

        axios.post(process.env.REACT_APP_API_URL2 + `/sale/list-available-carriers`, reqData, {
            headers: { "Content-Type": "application/json" }
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                if (res.data.data) {
                    let filteredData = res.data.data;
                    if (setData) setData(filteredData);
                } else {
                    if (setData) setData([]);
                }
            } else {
                if (setData) setData([]);
            }
        }).catch((e) => {
            console.log(e);
        })
    }

    const onChangeSearch = (keyword) => {
        loadClientsListData(keyword, setClientsListData);
    }

    const normalizeToLatin = (value) => {
        const greekToLatinMap = {
            'Α': 'A', 'Β': 'B', 'Ε': 'E', 'Ζ': 'Z', 'Η': 'H', 'Ι': 'I', 'Κ': 'K',
            'Μ': 'M', 'Ν': 'N', 'Ο': 'O', 'Π': 'P', 'Ρ': 'P', 'Τ': 'T', 'Υ': 'Y',
            'Φ': 'F', 'Χ': 'X'
        }
        return value.toUpperCase().split('').map(char => greekToLatinMap[char] || char).join('').replace(/[^A-Z0-9]/g, '');
    }

    const handleVehicleClick = (vehicleObject) => {
        console.log(vehicleObject);
        if (vehicleObject?.lastCarrierVatNumber) {
            axios.post(`${process.env.REACT_APP_API_URL2}/sale/manage-auto-transfer-carrier`, {
                company: company.id,
                vatNumber: vehicleObject?.lastCarrierVatNumber,
            }).then((res) => {
                if (res.data.status === "200") {
                    setSelectedClient({_id: res.data.data._id, name: res.data.data.name, vatNumber: res.data.data.vatNumber});
                    setRequestData({
                        ...requestData,
                        carrierVatNumber: res.data.data.lastCarrierVatNumber,
                        vehicleNumber: vehicleObject.vehicleNumber,
                        transportType: vehicleObject.transportType,
                    });
                }
            }).catch((err) => {
                console.log(err);
            })
        } else {
            setSelectedClient({_id: "", name: ""});
            setRequestData({
                ...requestData,
                vehicleNumber: vehicleObject.vehicleNumber,
                transportType: vehicleObject.transportType,
                carrierVatNumber: "",
            })
        }
    }

    return (
        <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={"modal42PercentWidth"}>
            <Modal.Header closeButton>
                <Modal.Title>Έναρξη Διακίνησης</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {transferVehicles.length > 0 && (
                    <Row className={"g-3 mb-2"}>
                        {transferVehicles.map((t, idx) => (
                            <Col key={`tv-${idx}`} xs={6} md={3}>
                                <div
                                    role="button"
                                    className="vehicle-btn p-1 border rounded text-center shadow-sm bg-white"
                                    onClick={() => handleVehicleClick(t)}
                                >
                                    <strong>{t.vehicleNumber}</strong><br/>
                                    <div className={"text-muted"} style={{fontSize: "10px"}}>{transportTypes.find((el) => el.value === t.transportType)?.label}</div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                )}
                <Row>
                    <Col md={6}>
                        <Dropdown
                            name={"transportType"}
                            label={"Είδος Μεταφορικού Μέσου"}
                            options={transportTypes}
                            className={"mb-2"}
                            required={true}
                            defaultValue={transportTypes.find((el) => el.value === requestData.transportType)}
                            onChange={(e) => setRequestData({...requestData, transportType: e.value})}
                        />
                    </Col>
                    <Col md={6}>
                        <Input
                            name={"vehicleNumber"}
                            label={"Αριθμός Οχήματος"}
                            className={"mb-2"}
                            required={true}
                            value={requestData.vehicleNumber}
                            onChange={(e) => {
                                const vehicleNumber = normalizeToLatin(e.target.value);
                                setRequestData({...requestData, vehicleNumber});
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Input
                            name={"pNumber"}
                            label={"Αριθμός Κυλοφορίας Ρυμουλκούμενου"}
                            placeholder={"Εισάγετε αριθμό Κυλοφορίας Ρυμουλκούμενου, αν υπάρχει"}
                            className={"mb-2"}
                            value={requestData.pNumber}
                            onChange={(e) => setRequestData({...requestData, pNumber: e.target.value})}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={isEmpty(selectedClient._id) ? 12 : 11}>
                                <AdvancedCombobox
                                    ACName="Sales Client" // do not change name
                                    className="w-100 ac-select-dropdown"
                                    label={"Μεταφορική εταιρεία"}
                                    data={clientsListData}
                                    defaultValue={selectedClient?.name ? `${selectedClient.vatNumber} - ${selectedClient.name}` : ""}
                                    key={selectedClient.name}
                                    onChange={(e) => {
                                        setSelectedClient({
                                            _id: e.row._id,
                                            name: e.row.name,
                                            vatNumber: e.row.vatNumber,
                                        })
                                        setRequestData({...requestData, carrierVatNumber: e.row.vatNumber});
                                    }}
                                    resetFilter={() => {
                                        setSelectedClient({
                                            _id: "",
                                            name: "",
                                            vatNumber: "",
                                        });
                                        setRequestData({...requestData, carrierVatNumber: ""});
                                    }}
                                    onChangeSearch={(keyword) => onChangeSearch(keyword)}
                                    excludeColumns={[]}
                                    columns={clientDropdownColumns}
                                    deleteEnable={false}
                                    searchTableEnable={false}
                                    showTableOptionOnSelect={true}
                                    placeholder={"Επιλέξτε μεταφορική εταιρεία, αν υπάρχει"}
                                    required={false}
                                    name="clientName"
                                    showInsertAddButton={true}
                                    hideSaveButton={true}
                                    hideInsertNewRow={true}
                                    inputFieldClasses="form-control"
                                    disabled={String(selectedClient._id).length === 24}
                                />
                                <div className={"mt-2"}>(*) Σε περίπτωση που δεν επιλεχθεί μεταφορική εταιρεία, θα θεωρείτε η επιχείρηση σας ως μεταφορική εταιρεία</div>
                            </Col>
                            {!isEmpty(selectedClient._id) && (
                                <Col md={1}>
                                    <button
                                        style={{paddingTop: "35px"}}
                                        className="btn btn-sm"
                                        title={"Καθαρισμός"}
                                        onClick={() => setSelectedClient({_id: "", name: ""})}>
                                        <i className="fas fa-xmark"></i>
                                    </button>
                                </Col>
                            )}
                        </Row>
                    </Col>
                </Row>
                <hr className={"mt-2 mb-2"} />
                <div className={"text-muted mb-2"}><i>Δηλώσεις Συσκευασιών (Προαιρετικό)</i></div>
                <Row>
                    <Col md={12}>
                        <PackingsDeclarations
                            packingsDeclarations={requestData.packingsDeclarations}
                            callbackFunction={(arr) => {
                                setRequestData({...requestData, packingsDeclarations: arr});
                            }}
                            viewMode={false}
                            mdWidth={6}
                        />
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={() => setShow(false)} disabled={loading}>
                    Κλείσιμο
                </Button>
                <Button variant="primary" onClick={() => onAccept()} disabled={loading}>
                    Καταχώρηση {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default RegisterTransferModal;
